/**
 * Feature-specific limitations text shown in the BETA info bubble
 */
export const USE_CASE_LIMITATIONS: Record<string, string> = {
  "past-deals":
    "DealOS ingests published PE deals that reached PIR after 2011 and Private Credit deals with published IC papers. Sensitive deals, flash / IPV reports, PCRs not currently indexed. Other strategies coming soon.",
  "research-desk":
    "Research Desk surfaces IC papers, sector analyses, market overviews, and company profiles from the CVC research library. Coverage depends on what has been indexed — newly published research may not appear immediately.",
  "expert-finder":
    "Expert Finder ranks CVC people by their historical PE deal-team participation. It does not cover other strategies, and it is not an HR directory — it doesn't show availability, office or current role.",
};

/**
 * Document color palette for fact badges
 * Uses CVC secondary colors for visual distinction across documents
 */
const DOCUMENT_COLORS = [
  { bg: "bg-cvc-lb2", text: "text-cvc-blue", border: "border-cvc-lb1" },
  { bg: "bg-emerald-50", text: "text-cvc-green", border: "border-emerald-200" },
  { bg: "bg-cyan-50", text: "text-cvc-marine", border: "border-cyan-200" },
  { bg: "bg-purple-50", text: "text-cvc-purple", border: "border-purple-200" },
  { bg: "bg-red-50", text: "text-cvc-coral", border: "border-red-200" },
  { bg: "bg-amber-50", text: "text-cvc-yellow", border: "border-amber-200" },
];

/**
 * Get color scheme for a document based on its display index
 */
export function getDocumentColor(documentDisplayIndex: number): {
  bg: string;
  text: string;
  border: string;
} {
  const index = (documentDisplayIndex - 1) % DOCUMENT_COLORS.length;
  return DOCUMENT_COLORS[index] || DOCUMENT_COLORS[0];
}

/**
 * Check if a message is an internal system message that should be hidden from the UI
 * These are control messages used for internal communication between frontend and backend
 */
export function isInternalMessage(message: { text?: string; sender?: string }): boolean {
  const text = message.text || "";
  // Hide CONTROL_* messages (file uploads, feedback, etc.)
  if (text.startsWith("CONTROL_")) return true;
  // Hide SYSTEM_* messages (status checks, triggers, etc.)
  if (text.startsWith("SYSTEM_")) return true;
  return false;
}

/** Matches the inline fact markers emitted by the streaming parser. */
export const FACT_PATTERN = /\[\[FACT:([^\]]+)\]\]/g;

/** Collect the fact ids referenced in a block of message text. */
export function factIdsInText(text: string): Set<string> {
  const factIds = new Set<string>();
  const pattern = new RegExp(FACT_PATTERN.source, "g");
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(text)) !== null) {
    factIds.add(match[1]);
  }

  return factIds;
}
